module.exports = __webpack_public_path__ + "img/eff04Bigpc.963e181a.png";